import "@idds/vue/index.css";
import { setBrandTheme } from "@idds/vue";

setBrandTheme("lan");

export default defineNuxtPlugin((app) => {});
